import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../../assets/images/logo.png';
import './onboarding/onboarding.css';

const PhoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="6" y="2" width="12" height="20" rx="2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M11 18h2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const MailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3 7l9 6 9-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const JoinEntry = () => {
  const navigate = useNavigate();

  return (
    <div className="ob-root">
      <div className="ob-join-page">
        <div className="ob-join-inner">
          <div className="ob-join-hero">
            <span className="ob-join-glow ob-join-glow-a" />
            <span className="ob-join-glow ob-join-glow-b" />
            <div className="ob-join-hero-deco" aria-hidden="true" />
            <div className="ob-join-hero-content">
              <img src={logo} alt="Nemonto" className="ob-join-logo-img" />
              <span className="ob-join-kicker"><span className="ob-join-kicker-dot" />Free to join, always</span>
              <div className="ob-join-tagline">You're invited to the table.</div>
              <p className="ob-join-hero-copy">
                Post a recipe, watch someone make it their own, and turn dinner into a running
                conversation with cooks who get it.
              </p>
              <div className="ob-join-proof">
                <div className="ob-join-avatar-row">
                  <span style={{ background: '#FAC775' }} />
                  <span style={{ background: '#F0997B' }} />
                  <span style={{ background: '#9FE1CB' }} />
                  <span style={{ background: '#AFA9EC' }} />
                </div>
                <p><strong>300+ home cooks</strong> already pulled up a chair</p>
              </div>
            </div>
          </div>
          <div className="ob-join-sheet">
            <div className="ob-join-sheet-inner">
              <h2>Join the community</h2>
              <p className="ob-join-sub">Cook. Share. Gather.</p>

              <button
                type="button"
                className="ob-btn-outline"
                onClick={() => navigate('/auth/onboarding?method=phone')}
              >
                <span className="ob-btn-icon"><PhoneIcon /></span>
                Continue with Phone
              </button>
              <button
                type="button"
                className="ob-btn-outline"
                onClick={() => navigate('/auth/onboarding?method=email')}
              >
                <span className="ob-btn-icon"><MailIcon /></span>
                Continue with Email
              </button>

              <div className="ob-join-divider">or</div>

              <p className="ob-link-plain">
                Already have an account? <Link to="/auth/sign-in">Sign in</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinEntry;
